const waitUntilGoogleScriptsLoaded = () => {
  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    setTimeout(() => {
      waitUntilGoogleScriptsLoaded();
    }, 500);
  } else {
    if (document.getElementById("js-google-map") && document.getElementById("js-google-map").querySelector('div')) {
      initMap();
    }

    if (document.getElementById('js-google-autocomplete')) {
      initAutocomplete();
    }
  }
}

var initMapCallback = () => {
  if (document.getElementById('js-gmaps-script') === null && typeof loadGmapsScripts == 'function') {
    loadGmapsScripts();
  }
  waitUntilGoogleScriptsLoaded();
}


var initMap = () => {

  const mapEl = document.getElementById("js-google-map");

  // Find marker elements within map.
  const markers = mapEl.querySelectorAll('.marker');

  const map = new google.maps.Map(mapEl, {
    center: { lat: -33.866, lng: 151.196 },
    zoom: parseInt(mapEl.getAttribute('data-zoom')) || 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: [
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ]
  });
  let bounds = new google.maps.LatLngBounds();

  map.markers = [];

  const request = {
    placeId: markers[0].getAttribute('data-placeId'),
    fields: ["name", "formatted_address", "place_id", "geometry" , "opening_hours"],
  };

  const service = new google.maps.places.PlacesService(map);

  service.getDetails(request, (place, status) => {
    if (
      status === google.maps.places.PlacesServiceStatus.OK &&
      place &&
      place.geometry &&
      place.geometry.location
    ) {
      const icon = {
        url: "/wp-content/themes/liikku/dist/images/liikku-karttamerkki.png", // url
        scaledSize: new google.maps.Size(50, 69.5), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(25, 67) // anchor
      };
      const marker = new google.maps.Marker({
        map,
        position: place.geometry.location,
        icon: icon
      });

      map.markers.push(marker);

      const bounds = new google.maps.LatLngBounds();
      map.markers.forEach(
        function(marker) {
          bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
          });
        }
      );

      // Single marker.
      if( map.markers.length == 1 ){
        map.setCenter(bounds.getCenter());
      // Multiple markers.
      } else{
        map.fitBounds(bounds);
      }
    }
  });
}

function initAutocomplete() {
  if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
    const geocoder = new google.maps.Geocoder();
    const getPlaceButton = document.getElementById('js-google-get-place');
    const autocompleteEl = document.getElementById('js-google-autocomplete');
    const autocompleteResult = document.getElementById('js-google-autocomplete-result');
    const autocomplete = new google.maps.places.Autocomplete(
      (autocompleteEl),
      {
        componentRestrictions: { country: "fi" },
        types: [ '(cities)' ]
      }
    );

    autocomplete.addListener('place_changed', () => {

      if (document.querySelector('.hero__form')) {
        document.querySelector('.hero__form').classList.add('state--loading', 'state--loading-big');
      }
      geocoder.geocode({ 'address': autocompleteEl.value }, function(results, status) {
        if (status == 'OK') {
          const location = results[0].geometry.location;

          const result = {
            lat: location.lat(),
            lng: location.lng(),
            address: autocompleteEl.value
          };

          const resultString = JSON.stringify(result);
          autocompleteResult.value = resultString;

          // Trigger the event
          const changeEvent = new Event('change');
          autocompleteResult.dispatchEvent(changeEvent);
        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    });

    getPlaceButton.addEventListener('click', () => {
      if (document.querySelector('#co-ajax')) {
        document.querySelector('#co-ajax').classList.add('state--loading', 'state--loading-big');
      } else if (document.querySelector('.hero__form')) {
        document.querySelector('.hero__form').classList.add('state--loading', 'state--loading-big');
      }

      navigator.geolocation.getCurrentPosition((currentPosition) => {
        const position = {
          lat: currentPosition.coords.latitude,
          lng: currentPosition.coords.longitude,
          address: '',
        };

        const resultString = JSON.stringify(position);
        autocompleteResult.value = resultString;

        // Trigger the event
        const changeEvent = new Event('change');
        autocompleteResult.dispatchEvent(changeEvent);
      },(err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
      },{
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    });

    // For menu item link with 'initSearch=kaupungin_nimi' url parameter
    if (autocomplete && window.location.search.substr(1)) {
      const items = location.search.substr(1).split("&");
      for (const item of items) {
        const tmp = item.split("=");
        if (tmp[0] === 'initSearch') {
          geocoder.geocode({ 'address': decodeURIComponent(tmp[1]) }, function(results, status) {
            if (status == 'OK') {
              const location = results[0].geometry.location;

              const result = {
                lat: location.lat(),
                lng: location.lng(),
                address: decodeURIComponent(tmp[1])
              };

              const resultString = JSON.stringify(result);
              autocompleteResult.value = resultString;

              // Trigger the event
              const changeEvent = new Event('change');
              autocompleteResult.dispatchEvent(changeEvent);
            } else {
              alert('Geocode was not successful for the following reason: ' + status);
            }
          });
        }
      }
    };

  }
}

// window.addEventListener('DOMContentLoaded', () => {
//   initMapDelay();
// });

